import fetch from './fetch';
import base from './base';
import sys from './sys';
import teacher from './teacher';
import classApi from './classApi';
import contact from './contact';
import message from './message';
import frontInf from './frontInf';
import finance from './finance';
import report from './report';
import notice from './notice';
import noticeConfirm from './noticeConfirm';
import logger from './logger';

const getMenu = () => fetch({ url: '/allow_menu', isFull: true });
const getAllowOperate = ({ menu_id }) => fetch({ url: `/allow_operate/${menu_id}`, isFull: true });
const login = params =>
  fetch({
    url: '/login',
    methold: 'post',
    params,
    isFull: true
  });

const getUser = params => fetch({ url: '/get_current_user', params, isFull: true });
const refreshToken = params =>
  fetch({
    url: '/refresh_token',
    params,
    methold: 'post',
    isFull: true
  });
const logout = () =>
  fetch({
    url: '/logout',
    isFull: true,
    methold: 'post'
  });

const getOssUrl = () =>
  fetch({
    url: '/oss_base_url'
  });

const upload = config =>
  fetch({
    url: '/upload',
    methold: 'post',
    config
  });

const resetSms = params =>
  fetch({
    url: '/reset/sms_send',
    methold: 'post',
    params
  });

const reset = ({ params, methold }) =>
  fetch({
    url: '/reset',
    methold,
    params
  });

const fetchStsToken = () =>
  fetch({
    url: '/fetch_sts_token'
  });

const getCurrentSysMsg = () =>
  fetch({
    url: '/get_current_sys_msg'
  });

const readSysMsg = ({ msg_id }) =>
  fetch({
    url: `/sys_msg/${msg_id}`,
    methold: 'patch'
  });

const pieChart = ({ params }) =>
  fetch({
    url: '/pie_chart_msg',
    params
  });
const fetchGetSmsCode = params => fetch({ url: '/sendAdminSms', params, methold: 'post', isSSO: true, config: { headers: { 'content-type': 'application/json' } } });
const fetchSmsCodeLogin = params => fetch({ url: '/adminPhoneLogin', params, methold: 'post', isSSO: true });
const fetchSmsCodeLoginTicket = params => fetch({ url: '/st_validate', params, methold: 'post' });
export {
  readSysMsg,
  getCurrentSysMsg,
  upload,
  getOssUrl,
  getMenu,
  getAllowOperate,
  login,
  getUser,
  refreshToken,
  logout,
  base,
  sys,
  teacher,
  classApi,
  contact,
  message,
  frontInf,
  finance,
  resetSms,
  reset,
  report,
  pieChart,
  fetchStsToken,
  notice,
  noticeConfirm,
  fetchGetSmsCode,
  fetchSmsCodeLogin,
  fetchSmsCodeLoginTicket,
  logger
};
